<template>
  <div>
    <template>
      <div class="input-group">
      <label>身份选择</label>
      <el-radio-group v-model="auth" >
      <el-radio  label="1">设计师</el-radio>
      <el-radio  label="2">买家</el-radio>
      </el-radio-group>
      </div>
    </template>
    <template v-if="auth==2">
      <div class="input-group">
      <label>身份选择</label>
      <el-radio-group v-model="job" @change="changeAuth">
        <el-radio  label="1">个人</el-radio>
        <el-radio  label="2">企业</el-radio>
      </el-radio-group>
      </div>
    </template>
    <template v-if="auth==1">
      <div class="input-group">
      <label>身份选择</label>
      <el-radio-group v-model="job" @change="changeAuth">
        <el-radio  label="3">平面设计师</el-radio>
        <el-radio  label="4">效果设计师</el-radio>
        <el-radio  label="5">动画设计师</el-radio>
      </el-radio-group>
      </div>
    </template>
    <InputGroup v-if="job" icon="icontel" :placeholder="nicknameText" v-model="nickname"></InputGroup>
    <InputGroup icon="icontel" placeholder="请输入手机号" v-model="mobile"></InputGroup>
    <InputGroup placeholder="请输入验证码" v-model="code">
      <div class="code-btn" @click="sendCode" v-show="verification">{{sendText}}</div>
      <div class="code-btn not" v-show="!verification">重新发送({{timer}})</div>
    </InputGroup>

  </div>
</template>

<script>
import InputGroup from "@/components/layout/InputGroup.vue";
export default {
  name: "CodeInputGroup",
  components: { InputGroup },
  props: {},
  data() {
    return {
      mobile: "",
      code: "",
      verification: true,
      sendText: "获取验证码",
      timer: 60,
      auth_timer: "",
      auth:"",
      job:"",
      nickname:"",
      nicknameText:""

    };
  },
  watch: {
    mobile(val) {
      this.$emit("getTelPhone", val);
      this.$emit("getInputError", this.rightMobile.msg);
    },
    code(val) {
      this.$emit("getSmsCode", val);
    },
    job(val) {
      this.$emit("getJob", val);
    },
    nickname(val){
      this.$emit("getNickName", val);
    },
  },
  computed: {
    // 验证手机号
    rightMobile() {
      let res = {};
      if (!this.mobile) {
        res.status = false;
        res.msg = "请输入手机号";
      } else if (!/^1[345678]{1}\d{9}$/gi.test(this.mobile)) {
        res.status = false;
        res.msg = "手机号格式不正确";
      } else {
        res.status = true;
        res.msg=""
      }
      return res;
    }
  },
  methods: {
    changeAuth(val){
      if(val==1){
        this.nicknameText="请输入个人昵称";
      }
      else if(val==2){
        this.nicknameText="请输入企业名称";
      }else{
        this.nicknameText="请输入昵称";
      }

    },
    sendCode() {
      if (!this.rightMobile.status) {
        return this.$emit("getInputError", this.rightMobile.msg);
      } else {
        this.$api.sms({ mobile: this.mobile, code: "login" }).then(res => {
          if (res.status) {
            this.verification = false;
            this.countDown(); // 执行验证码计时
          } else {
            this.$emit("getInputError", res.msg);
          }
        });
      }
    },
    countDown() {
      let auth_timer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.verification = true; // 60s时间结束还原v-show状态并清除定时器
          this.timer = 60;
          clearInterval(auth_timer);
          this.sendText = "重新发送";
        }
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.auth_timer);
  }
};
</script>
<style lang="scss" scoped>
  .input-group{ height: 40px;margin-bottom: 16px; display: flex; align-items: center;
  label{
     width: 80px;
  }
  }
.code-btn {
  width: 84px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #ea4b49;
  font-weight: 400;
  border-left: 1px solid rgba(220, 220, 220, 1);
  cursor: pointer;
  &.not {
    color: #999;
  }
}
</style>